export const iconFontAwesomeMapsTicket = (
	<i className="fa-solid fa-ticket"></i>
);
